module.exports = __webpack_public_path__ + "static/img/5.5b195b7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/3/zh/5.png
// module id = DKKY
// module chunks = 0